import script from "./SignAgreement.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignAgreement.vue?vue&type=script&setup=true&lang=ts"

import "./SignAgreement.vue?vue&type=style&index=0&id=30e1b887&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/lpoa_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30e1b887"]])

export default __exports__